const requestOptions = {
    errorDialog: true,
    secure: false,
    baseURL: true,
    repeatRequestCancel: false,
    responseType: 'json',
    closeAlert: false,
    formData: false,
};
Object.freeze(requestOptions);
export { requestOptions };
